export const featureddata = [
	{
		id: 1,
		img: '/images/feature1.jpg',
		title: 'Sony Speaker',
        price:240,
        reviews:20,
        rating:3,
		desc: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt in culpa qui officia deserunt.'
	},
	{
		id: 1,
		img: '/images/feature3.jpg',
		title: 'Apple Watch',
        price:350,
        reviews:5,
        rating:5,

		desc: 'Aenean gravida dignissim finibus. Nullam ipsum diam, posuere vitae pharetra sed, commodo ullamcorper.'
	},
	{
		id: 1,
		img: '/images/feature2.jpg',
		title: 'Camera',
        price:690,
        reviews:12,
        rating:4,
		desc:
			'Curabitur ac mi sit amet diam luctus porta. Phasellus pulvinar sagittis diam, et scelerisque ipsum lobortis nec.'
	}
];
